import { createAction, props } from '@ngrx/store';

export const changeState = createAction('[Menu Component] Change State Menu');
export const setOpen = createAction('[Menu Component] Set Open State', props<{ open: boolean }>());
export const setPermanent = createAction('[Menu Component] Set Permanent State', props<{ permanent: boolean }>());
